export const DASHBOARD = 'IMD';
export const SKU = 'IMS';
export const ITEM = 'IMIA';
export const PACKAGE = 'IMPA';
export const TAG = 'IMT';
export const LOCATION = 'IML';
export const AUDIT = 'IMIAL';
export const DOWNLOAD_CENTER = 'IMDC';
export const EXPORT_ITEMS_DETAILS = 'IMEID';
export const EXPORT_PACKAGES_DETAILS = 'IMEPD';
export const EXPORT_ITEMS_AVAILABILITY = 'IMEIA';
export const EXPORT_PACKAGES_AVAILABILITY = 'IMEPA';
export const EXPORT_ITEMS_LOGS = 'IMEIL';
export const EXPORT_LOCATIONS = 'IMEL';
export const EXPORT_TAGS = 'IMET';
